export const ConsumerPhoneNumberViewUat = {
  header: 'workflow.consumerPhoneNumber.header',
  infoMessage: 'workflow.consumerPhoneNumber.infoMessage',
  warningMessage: 'workflow.consumerPhoneNumber.warningMessage',
  disclaimerMessage: 'workflow.consumerPhoneNumber.disclaimerMessage',
}
